module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Prai-title"
  }, [_c('span', [_vm._v("PRAISE FOR THE WRITING OF KATHERINE NEVILLE")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-section1"
  }, [_c('span', [_c('i', [_vm._v("The Eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“With alchemical skill, Neville blends modern romance, historical fiction, and medieval mystery … and comes up with gold.” —"), _c('i', [_vm._v("People")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“A fascinating piece of entertainment that manages to be both vibrant and cerebral. … Few will find it resistible.” —"), _c('i', [_vm._v("Los Angeles Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“Daring, original, and moving, ["), _c('i', [_vm._v("The Eight")]), _vm._v("] seems destined to become a cult classic.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“Readers thrilled by "), _c('i', [_vm._v("The Da Vinci Code")]), _vm._v(" will relish the multilayered secrets of "), _c('i', [_vm._v("The Eight")]), _vm._v(".” —Matthew Pearl, author of "), _c('i', [_vm._v("The Dante Club")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“A feminist answer to "), _c('i', [_vm._v("Raiders of the Lost Ark")]), _vm._v(".” —"), _c('i', [_vm._v("The Washington Post Book World")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“The female counterpart to Umberto Eco’s "), _c('i', [_vm._v("The Name of the Rose")]), _vm._v(" … impossible to put down.” —"), _c('i', [_vm._v("Boston Herald")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-section1"
  }, [_c('span', [_c('i', [_vm._v("A Calculated Risk")])])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-section2"
  }, [_c('span', [_vm._v("A New York Times Notable Book")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“Never a dull moment, and [Neville] makes it all the more plausible because of her intimate knowledge of how international banking works. … [Her] book churns up wave after wave of excitement.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“Great fun … [A] lean, taut thriller.” —"), _c('i', [_vm._v("San Jose Mercury News")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-section1"
  }, [_c('span', [_c('i', [_vm._v("The Magic Circle")])])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“Filled with intrigue … Neville keeps the novel moving at a fast pace.” —"), _c('i', [_vm._v("The Denver Post")])]), _vm._v(" "), _c('p', {
    staticClass: "Prai-normal"
  }, [_vm._v("“[A] racing-across-the-globe, one-step-ahead-of-the-bad-guys treasure hunt.” —"), _c('i', [_vm._v("Detroit Free Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4968b930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter02.vue
// module id = 69
// module chunks = 0